/* eslint-disable @typescript-eslint/no-empty-interface */
import '../../facilitate/AssessmentDetails.scss';
import './ResultsReviewAll.scss';

import { AssessmentStatus } from '@amzn/awscat-aws-assessment-service-typescript-client';
import { Box } from '@amzn/awsui-components-react';
import { useEffect } from 'react';

import ResultsReviewAllBody from './ResultsReviewAllBody';
import { clearAppHelpPanel } from '../../../common/help-panel/AppHelpPanelSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import AssessmentDetailsHeader from '../../facilitate/header/AssessmentDetailsHeader';

const ResultsReviewAll = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const currentAssessmentStatus = useAppSelector((state) => state.currentAssessmentState.currentAssessmentOrSelectedSnapshot.status);

    useEffect(() => {
        const cleanup = () => {
            // Component unmounted, update help panel to default
            dispatch(clearAppHelpPanel());
        };
        return cleanup;
    }, [dispatch]);

    return (
        <Box className='awscat-assessment-results'>
            <AssessmentDetailsHeader
                showLiveSession={true}
                readOnly={true}
                showSnapshots={true}
                showCompleteAssessment={currentAssessmentStatus === AssessmentStatus.IN_PROGRESS}
            />
            <ResultsReviewAllBody />
        </Box>
    );
};

export default ResultsReviewAll;
